
import React from "react";
import "./reset.css";
import "./App.css";
import styled from "@emotion/styled";
import Nav from "./components/Nav";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      link: "",
      name: "",
      socials: {},
      blurb: ""
    };
  }

  componentDidMount() {
    const link = window.location.href.split("=")[1]
    if (link) {
      this.setState({
        link: link,
        name: link.substring(
          link.lastIndexOf("/") + 1, 
          link.lastIndexOf("-")),
        socials: {
          twitter: `https://twitter.com/intent/tweet?text=I%27ve%20been%20using%20Pathpoint%20for%20my%20commercial%20P%26C%20wholesale%20needs%20and%20I%27d%20really%20recommend%20it.%20They%20can%20quote%20in%20as%20fast%20as%204%20minutes!%20%0A%0AUse%20my%20referral%20link%20to%20sign%20up%20and%20you%27ll%20earn%20money%20when%20you%20bind%3A%20&url=${link}`,
          linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${link}`,
          facebook: `https://www.facebook.com/sharer.php?u=${link}`
        },
        blurb: `I've been using Pathpoint for my commercial P&C wholesale needs and I'd really recommend it. They can quote in as fast as 4 minutes! Use my referral link to sign up and you'll earn money when you bind: ${link}`
      })  
    } else {
      const linkInput = prompt("It seems we can't find your unique link. Can you enter it here please?")
      this.setState({
        link: linkInput,
        name: linkInput.substring(
          linkInput.lastIndexOf("/") + 1, 
          linkInput.lastIndexOf("-")),
        socials: {
          twitter: `https://twitter.com/intent/tweet?text=I%27ve%20been%20using%20Pathpoint%20for%20my%20commercial%20P%26C%20wholesale%20needs%20and%20I%27d%20really%20recommend%20it.%20They%20can%20quote%20in%20as%20fast%20as%204%20minutes!%20%0A%0AUse%20my%20referral%20link%20to%20sign%20up%20and%20you%27ll%20earn%20money%20when%20you%20bind%3A%20&url=${linkInput}`,
          linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${linkInput}`,
          facebook: `https://www.facebook.com/sharer.php?u=${linkInput}`
        },
        blurb: `I've been using Pathpoint for my commercial P&C wholesale needs and I'd really recommend it. They can quote in as fast as 4 minutes! Use my referral link to sign up and you'll earn money when you bind: ${linkInput}`
      })
    }
  }

  render() {
    const {link, name, socials, blurb} = this.state
    return (
      <div className="App">
        <Nav title="Pathpoint Referral Program" />
        <div id="main">
          {link ? (
            <>
              <h1>Hi {name}!</h1>
              <h2>Your unique referral link is: <span>{link}</span></h2>
              <h3>To make referring people even easier, we wanted to share this blurb that you can copy / paste to whomever you want to refer:</h3>
              <p>{blurb}</p>
              <StyledButton onClick={() => navigator.clipboard.writeText(blurb)}>Copy to clipboard</StyledButton>
              <h3>Finally, to share to social media in 1 click, just press one of the buttons below:</h3>
              <div className="buttons">
                <a target="_blank" rel="noopener noreferrer" href={socials.facebook}> Facebook</a>
                <a target="_blank" rel="noopener noreferrer" href={socials.twitter}> Twitter</a>
                <a target="_blank" rel="noopener noreferrer" href={socials.linkedin}> LinkedIn</a>
              </div>
            </> 
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
}

export default App;

const StyledButton = styled.button`
  cursor: pointer;
  border-radius: 3px;
  border: 1px solid transparent;
  background: #000d93;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  padding: 7.5px 15px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  outline: none;
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  font-size: .75rem;
  :hover {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    background: #00c7e3;
  }
`;
